import { useLocalization } from '@/services/localizationService';

export default function SupportSubtitle() {
  const { t, data } = useLocalization();
  return (
    <div className="mt-10 R14 md:R16 mx-10">
      <div className="max-w-[500px] m-auto">
        {t(data.support.dedicatedCustomerSupport)}
      </div>
    </div>
  );
}
